module.exports = "<form #filterSearch=\"ngForm\" autocomplete=\"off\">\n  <input type=\"text\" id=\"search\" name=\"search\" class=\"form-control\" placeholder=\"Buscar\" [ngModel]=\"model.search || ''\" [formControl]=\"search\">\n  <select class=\"form-control\" id=\"filter\" name=\"filter\" [(ngModel)]=\"model.filter\" (change)=\"onChange($event.target.value)\">\n    <option *ngFor=\"let c of filter.column\" [value] = \"c.name\">{{c.nickname}}</option>\n    <option value=\"__all\">Todos</option>\n  </select>\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/filter/filter.component.html
// module id = 707
// module chunks = 0